import { Box, BoxProps } from '@careguide/theme'
import Avatar from 'components/generic/Avatar'
import styled from 'styled-components'

export type StyledAvatarProps = {
  isDefaultAvatar: boolean
}

export const Headline = styled(Box)`
  word-break: break-word;
`

export const FeaturedBannerContainer = styled(Box)`
  justify-content: left;
`

export const Body = styled(Box)`
  justify-content: center;
  text-align: center;
`

export const StyledAvatar = styled(Avatar)<StyledAvatarProps & BoxProps>`
  cursor: ${(props) => (props.isDefaultAvatar ? 'unset' : 'pointer')};
  margin: 0 auto;
`
